export default __webpack_public_path__ + "static/media/hero.9825315b.png";